import React, {useEffect} from 'react';
import ButtonSkeleton from 'app/components/authProvider/buttons/ButtonSkeleton';
import FacebookFederatedButton from 'app/components/authProvider/buttons/FacebookFederatedButton';
import useFacebookInitialization, {ButtonState} from 'app/components/authProvider/buttons/useFacebookInitialization';

export default function FacebookButton({onClick, initialized, onInitialized}) {
  const buttonState = useFacebookInitialization();

  useEffect(() => {
    if (buttonState !== ButtonState.PENDING) {
      onInitialized();
    }
  }, [buttonState, onInitialized]);

  if (!initialized || buttonState === ButtonState.PENDING) {
    return <ButtonSkeleton />;
  }

  if (buttonState === ButtonState.ERROR) {
    return <FacebookFederatedButton disabled={true} onClick={() => {}} />;
  }

  return <FacebookFederatedButton onClick={onClick} />;
}
